import React, { useState } from 'react';
import { TextField, Button, Box, Typography, Paper, Alert } from '@mui/material';
import api from '../utils/api';
import { useNavigate } from 'react-router-dom';

// Custom SVG illustration for registration (smiling sun/book)
const HappySunBookSVG = () => (
  <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginBottom: 12 }}>
    <circle cx="40" cy="40" r="24" fill="#FFFDE7" stroke="#FFD54F" strokeWidth="2"/>
    <path d="M40 24V16M40 64v-8M24 40H16M64 40h-8M28.3 28.3l-5.7-5.7M57.4 57.4l-5.7-5.7M28.3 51.7l-5.7 5.7M57.4 22.6l-5.7 5.7" stroke="#FFD54F" strokeWidth="2" strokeLinecap="round"/>
    <rect x="24" y="48" width="32" height="12" rx="4" fill="#E0F7FA" stroke="#4FC3F7" strokeWidth="2"/>
    <rect x="32" y="52" width="16" height="4" rx="2" fill="#81C784"/>
    <ellipse cx="34" cy="38" rx="2" ry="2.5" fill="#FFD54F"/>
    <ellipse cx="46" cy="38" rx="2" ry="2.5" fill="#FFD54F"/>
    <path d="M36 44c2 2 6 2 8 0" stroke="#81C784" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

export default function Register() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const res = await api.post('/api/auth/register', { name, email, password });
      localStorage.setItem('token', res.data.token);
      localStorage.setItem('teacher', JSON.stringify(res.data.teacher));
      navigate('/dashboard');
    } catch (err) {
      setError(err.response?.data?.error || err.message || 'Registration failed');
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #e0f7fa 0%, #fffde7 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: 'Nunito, sans-serif',
      }}
    >
      <Paper
        elevation={6}
        sx={{
          p: 5,
          minWidth: 350,
          borderRadius: 4,
          boxShadow: '0 8px 24px rgba(0,0,0,0.08)',
          textAlign: 'center',
          background: '#f9fafc',
        }}
      >
        <HappySunBookSVG />
        <Typography variant="h4" mb={1} fontWeight={700} fontFamily="Nunito, sans-serif">
          Create Your Teacher Account!
        </Typography>
        <Typography variant="subtitle1" mb={3} color="text.secondary">
          Join our community of educators 🌟
        </Typography>
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        <form onSubmit={handleSubmit}>
          <TextField
            label="Name"
            fullWidth
            margin="normal"
            value={name}
            onChange={e => setName(e.target.value)}
            required
            sx={{ borderRadius: 2, background: '#fff' }}
          />
          <TextField
            label="Email"
            type="email"
            fullWidth
            margin="normal"
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
            sx={{ borderRadius: 2, background: '#fff' }}
          />
          <TextField
            label="Password"
            type="password"
            fullWidth
            margin="normal"
            value={password}
            onChange={e => setPassword(e.target.value)}
            required
            sx={{ borderRadius: 2, background: '#fff' }}
          />
          <Button
            type="submit"
            variant="contained"
            fullWidth
            sx={{
              mt: 3,
              borderRadius: 2,
              fontWeight: 'bold',
              fontSize: '1.1rem',
              background: 'linear-gradient(90deg, #81c784 0%, #4fc3f7 100%)',
              color: '#fff',
              boxShadow: '0 2px 8px rgba(129,199,132,0.15)',
              '&:hover': {
                background: 'linear-gradient(90deg, #4fc3f7 0%, #81c784 100%)',
              },
            }}
          >
            Register
          </Button>
        </form>
        <Button
          onClick={() => navigate('/login')}
          sx={{
            mt: 2,
            color: '#81c784',
            fontWeight: 'bold',
            borderRadius: 2,
            textTransform: 'none',
          }}
          fullWidth
        >
          Back to Login
        </Button>
      </Paper>
    </Box>
  );
} 